// extracted by mini-css-extract-plugin
export default {"add-new":"styles_add-new__V6BMQ"};